module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "slider",
    class: _vm.classes,
    on: {
      "click": _vm.$_sliderClick
    }
  }, [_c('div', {
    class: [_vm.prefixClass + '__wrap']
  }, [(_vm.range) ? [_c('div', {
    class: [_vm.prefixClass + '__handle'],
    style: ({
      left: _vm.firstPosition + '%'
    }),
    on: {
      "mousedown": _vm.$_onFirstHandleMousedown
    }
  }, [_c('t-tooltip', {
    ref: "tooltip",
    attrs: {
      "controlled": _vm.firstDragging,
      "content": _vm.tipFormat(_vm.currentValue[0]),
      "disabled": _vm.tipDisabled,
      "always": _vm.showTip === 'always',
      "placement": "top"
    }
  }, [_c('a', {
    class: _vm.firstButtonClasses,
    attrs: {
      "href": "javascript:void(0)"
    }
  })])], 1), _vm._v(" "), _c('div', {
    class: [_vm.prefixClass + '__handle'],
    style: ({
      left: _vm.secondPosition + '%'
    }),
    on: {
      "mousedown": _vm.$_onSecondHandleMousedown
    }
  }, [_c('t-tooltip', {
    ref: "tooltipSecond",
    attrs: {
      "controlled": _vm.secondDragging,
      "content": _vm.tipFormat(_vm.currentValue[1]),
      "disabled": _vm.tipDisabled,
      "always": _vm.showTip === 'always',
      "placement": "top"
    }
  }, [_c('a', {
    class: _vm.secondButtonClasses,
    attrs: {
      "href": "javascript:void(0)"
    }
  })])], 1)] : [_c('div', {
    class: [_vm.prefixClass + '__handle'],
    style: ({
      left: _vm.singlePosition + '%'
    }),
    on: {
      "mousedown": _vm.$_onHandleMousedown
    }
  }, [_c('t-tooltip', {
    ref: "tooltip",
    attrs: {
      "controlled": _vm.dragging,
      "content": _vm.tipFormat(_vm.currentValue),
      "disabled": _vm.tipDisabled,
      "always": _vm.showTip === 'always',
      "placement": "top"
    }
  }, [_c('a', {
    class: _vm.buttonClasses,
    attrs: {
      "href": "javascript:void(0)"
    }
  })])], 1)], _vm._v(" "), _c('div', {
    class: [_vm.prefixClass + '__track'],
    style: (_vm.barStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$_sliderClick($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.prefixClass + '__step'],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$_sliderClick($event)
      }
    }
  }), _vm._v(" "), (_vm.showStops) ? _c('div', {
    class: [_vm.prefixClass + '__mark']
  }, _vm._l((_vm.stops), function(item, index) {
    return _c('div', {
      key: index,
      class: [_vm.prefixClass + '__mark-stop'],
      style: ({
        'left': item.width + '%'
      }),
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.$_sliderClick($event)
        }
      }
    }, [(_vm.dataUnit && index == 0) ? _c('span', {
      class: [_vm.prefixClass + '__mark-stop-label'],
      domProps: {
        "innerHTML": _vm._s(_vm.dataUnit)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      class: [_vm.prefixClass + '__mark-stop-value'],
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })])
  }), 0) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb66d3ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/slider.vue
// module id = 405
// module chunks = 0